'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiZoomOutOutline = function TiZoomOutOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 20h-8.4c-0.4 0-0.8-0.4-0.8-0.8s0.4-0.9 0.8-0.9h8.4c0.4 0 0.8 0.4 0.8 0.9s-0.4 0.8-0.8 0.8z m10.6 6.6l-3.7-3.8c0.3-1.2 0.6-2.4 0.6-3.6 0-6.5-5.3-11.7-11.7-11.7s-11.7 5.2-11.7 11.7 5.3 11.6 11.7 11.6c1.3 0 2.5-0.2 3.6-0.6l4 4c1 0.8 2.3 1.3 3.5 1.3 2.9 0 5.2-2.3 5.2-5.2 0-1.4-0.5-2.7-1.5-3.7z m-6.5-1.9l4.2 4.3c0.3 0.3 0.5 0.8 0.5 1.3 0 1-0.8 1.9-1.9 1.9-0.5 0-1-0.2-1.3-0.5l-4.2-4.2c1.1-0.8 2-1.7 2.7-2.8z m-16.6-5.5c0-4.6 3.7-8.4 8.3-8.4s8.3 3.8 8.3 8.4-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3z' })
        )
    );
};

exports.default = TiZoomOutOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/zoom-out-outline.js
// module id = 2105
// module chunks = 0